
<!-- Resources -->
<div [ngStyle]="{ height: containerHeight == 'fill' ? '100%' : containerHeight + 'px' }" class="container">
  <ng-container *ngIf="!isUploading; else uploading">
    <ng-container *ngIf="!paginator.isLoading; else loading">

      <!-- Header -->
      <div class="header" style="height: 36px">

        <!-- Search bar -->
        <app-search-bar
          *ngIf="!environment.production"
          placeholder="Search resource..."
          [class.searchBarExpanded]="searchBarExpanded"
          (textSubmit)="filterResources($event)"
        ></app-search-bar>

        <div class="spacer"></div>

        <!-- Actions -->
        <div class="actions">
          <button *ngIf="uploadableResources.length > 0" mat-stroked-button color="primary" (click)="uploadResource()">
            <mat-icon>cloud_upload</mat-icon> {{ 'Upload resource' | translate }}
          </button>
        </div>

      </div>

      <!-- No resources -->
      <div *ngIf="resources.length == 0" class="no-item">
        {{ 'No resources found' | translate }}
      </div>

      <div
        class="resources-container"
        [ngStyle]="{gridTemplateColumns: 'repeat(auto-fill,minmax(' + getGridColumnSize() + ', 1fr))'}"
      >
        <app-grid-element
          *ngFor="let resource of resources"
          [id]="resource.id"
          [title]="resource.name"
          [bottomIcons]="[getBottomIcon(resource.type)]"
          [bottomIconText]="getBottomIconLabel(resource.type) | translate"
          [previewImage]="getImagePreviewPlaceholder(resource.type)"
          [previewOverlay]="true"
          [canEdit]="editable"
          (onEdit)="edit(resource)"
          [canRemove]="editable"
          (onRemove)="remove(resource)"
          [canClickBottomIcon]="selectable"
          (onBottomIconClicked)="openResource(resource)"
          [selectable]="selectable"
          [selected]="selectedResources.includes(resource.id)"
          [disabled]="isResourceDisabled(resource.type)"
          (click)="!selectable ? openResource(resource) : selectResource(resource)"
        ></app-grid-element>
      </div>

      <div class="spacer"></div>

      <!-- Paginator -->
      <mat-paginator
        [hidePageSize]="true"
        [disabled]="paginator.isLoading"
        [pageSize]="paginator.pageSize"
        [pageIndex]="paginator.currentPage"
        [length]="paginator.totalElements"
        (page)="paginator.pageChanged($event)"
        showFirstLastButtons>
      </mat-paginator>

    </ng-container>
  </ng-container>
</div>

<!-- Loading -->
<ng-template #loading>

  <div
    class="resources-container"
    [ngStyle]="{gridTemplateColumns: 'repeat(auto-fill,minmax(' + getGridColumnSize() + ', 1fr))'}"
  >
    <app-grid-element
      *ngFor="let i of [].constructor(cols * 4)"
      [isLoading]="true"
    ></app-grid-element>
  </div>

</ng-template>

<!-- Uploading spinner -->
<ng-template #uploading>
  <app-scotty-spinner [text]="'Uploading...' | translate" [diameter]="30"></app-scotty-spinner>
</ng-template>
